module.exports = __webpack_public_path__ + "img/user-png.684e4f5f.png";